import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import sessionManager from '../utils/sessionManager';

const API_BASE = "https://api.syncplay.live";

function HomePage() {
  const [inputRoomId, setInputRoomId] = useState('');
  const [status, setStatus] = useState('idle');
  const navigate = useNavigate();

  const createRoom = async () => {
    try {
      setStatus("creating room...");

      const res = await fetch(`${API_BASE}/rooms`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          'X-Session-Id': sessionManager.getSessionId() || '',
        },
      });

      const data = await res.json();

      if (!data.success) {
        alert(data.fa || data.message || "Error");
        setStatus("create room failed");
        return;
      }

      const newRoomId = data.data.roomId;
      navigate(`/room/${newRoomId}`);
    } catch (err) {
      alert("Create room failed.");
      setStatus("blocked/error");
    }
  };

  const joinRoom = async () => {
    const id = inputRoomId.trim().toUpperCase();

    if (!id) {
      alert("Enter room code");
      return;
    }

    try {
      setStatus("checking room...");

      const res = await fetch(`${API_BASE}/rooms/${id}`, {
        headers: {
          'X-Session-Id': sessionManager.getSessionId() || '',
        },
      });
      
      const data = await res.json();

      if (!data.success) {
        alert(data.fa || data.message || "Room not found");
        setStatus("join failed");
        return;
      }

      navigate(`/room/${id}`);
    } catch (err) {
      alert("Join room failed.");
      setStatus("blocked/error");
    }
  };

  return (
    <div className="join-section">
      <div className="card">
        <h2 className="card-title">Create a New Room</h2>
        <p className="card-description">
          Start a new sync session and invite friends
        </p>
        <button className="btn btn-primary" onClick={createRoom}>
          <span className="btn-icon">🎥</span>
          Create Room
        </button>
      </div>

      <div className="divider">
        <span>or</span>
      </div>

      <div className="card">
        <h2 className="card-title">Join Existing Room</h2>
        <p className="card-description">
          Enter room code to join a sync session
        </p>
        <div className="input-group">
          <input
            type="text"
            className="input"
            placeholder="Room code e.g. AB12C"
            value={inputRoomId}
            onChange={(e) => setInputRoomId(e.target.value.toUpperCase())}
            onKeyPress={(e) => e.key === 'Enter' && joinRoom()}
          />
          <button className="btn btn-secondary" onClick={joinRoom}>
            <span className="btn-icon">🔗</span>
            Join
          </button>
        </div>
      </div>
    </div>
  );
}

export default HomePage;